import saveIcon from "../../../../../assets/save.svg";
import cancelIcon from "../../../../../assets/cancel.svg";
import React from "react";

interface DeleteConfirmationStateProps {
    handleSaveDeleteClick: (event: React.MouseEvent) => void;
    handleCancelDeleteClick: (event: React.MouseEvent) => void;
}

const DeleteConfirmationState: React.FC<DeleteConfirmationStateProps> = ({ handleSaveDeleteClick, handleCancelDeleteClick }) => {
    return (
        <div className="flex w-full items-center justify-between">
            <span className="text-yellow-700 dark:text-yellow-500 py-1 px-2 rounded bg-neutral-300 dark:bg-neutral-800">Confirm Deletion ⚠️</span>
            <div className="flex items-center ml-1 space-x-1">
                <button onClick={handleSaveDeleteClick} className="p-1 hover:bg-neutral-200 dark:hover:bg-neutral-700 rounded-full">
                    <img src={`${saveIcon}`} alt="Confirm" className="h-4 w-4"/>
                </button>
                <button onClick={handleCancelDeleteClick} className="p-1 hover:bg-neutral-200 dark:hover:bg-neutral-700 rounded-full">
                    <img src={`${cancelIcon}`} alt="Cancel" className="h-5 w-5"/>
                </button>
            </div>
        </div>
    );
};

export default DeleteConfirmationState;